<template lang="pug">
div.itlp-checkout-input(v-if='key' :class="{'itlp-input-has-error': hasError, 'itlp-input-required': inputAttrs.required}")
	label(:for='inputId' :class='classes.label') {{label}}
	select(:id='inputId' :class='classes.input' v-model='controller.value.value' v-bind="inputAttrs")
		option(v-for="item in controller.selectOptions.value" :value="item.value") {{item.label}}
</template>
	
<script setup lang='ts'>
import { computed } from 'vue';
import type {PropType} from 'vue';
import type {InputController} from '@/apps/checkout/composables/useForm';

const props = defineProps({
	controller: {
		type: Object as PropType<InputController>,
		required: true
	}
});

const {key, label, hasError, inputAttrs} = props.controller;

const classes = computed(() => {
	return {
		label: {},
		input: {}
	}
});

const inputId = computed(() => {
	return key+'_'+String(Math.floor(Math.random() * 1000000))
});
	
</script>
	
<style>
.itlp-checkout-input{
	display: flex;
	flex-direction: column;
}
</style>